import type { ISO3166Alpha3 } from "@faire/web-api/indigofair/iso3166/ISO3166Alpha3";

import { StrictLocalizeFunction } from "../localization";

import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS as _ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "./ISO_TO_COUNTRY_NAME";

export const UPPERCASE_COUNTRY_NAME_TO_ISO = (
  strictLocalize: StrictLocalizeFunction
): Partial<
  Record<string, Exclude<keyof typeof ISO3166Alpha3, "ISO3166ALPHA3_UNKNOWN">>
> => {
  const ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS =
    _ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize);
  const uppercaseCountriesToIso = {};
  Object.keys(ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS).forEach(
    (iso) =>
      // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
      (uppercaseCountriesToIso[
        // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
        ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS[iso].toUpperCase()
      ] = iso)
  );
  return uppercaseCountriesToIso;
};
